const graphqlCacheConfig = {
  typePolicies: {
    PriceReport: {
      fields: {
        credit: {
          merge: true,
        },
      },
    },
    Review: {
      keyFields: ['reviewId'],
    },
    Station: {
      fields: {
        address: {
          merge: true,
        },
        prices: {
          merge: false,
        },
      },
    },
  },
};

export default graphqlCacheConfig;
